import React, { useEffect, useState } from 'react';
import Header from './sections/Header';
import Footer from './sections/Footer';
import About from './sections/About';
import Resume from './sections/Resume';
import Contact from './sections/Contact';
import Testimonials from './sections/Testimonials';
import Portfolio from './sections/Portfolio';
import ScrollProgress from './components/ScrollProgress';
import CursorGear from './components/CursorGear';

function App() {
  const [resumeData, setResumeData] = useState({});

  useEffect(() => {
    fetch('/resumeData.json')
      .then((res) => res.json())
      .then((data) => setResumeData(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="App">
      <ScrollProgress />
      <CursorGear />
      <Header data={resumeData.main} />
      <About data={resumeData.main} />
      <Resume data={resumeData.resume} />
      <Portfolio data={resumeData.portfolio} />
      <Testimonials data={resumeData.testimonials} />
      <Contact data={resumeData.main} />
      <Footer data={resumeData.main} />
    </div>
  );
}

export default App;
